import React, {useState} from "react"
import {Container, Grow, Grid, Paper, AppBar, TextField, Button} from "@material-ui/core"
import {useDispatch} from "react-redux"
import {useLocation, useHistory} from "react-router-dom"
import ChipInput from "material-ui-chip-input"

import useStyles from "./styles"
import Posts from "../Posts/Posts"
import Form from "../Form/Form"
import Paginate from "../Pagination"
import {getPostsBySearch} from "../../actions/posts"

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const Home = () => {
  const classes = useStyles()
  const [currentId, setCurrentId] = useState(0)
  const [search, setSearch] = useState("")
  const dispatch = useDispatch()
  const query = useQuery()
  const history = useHistory()
  const page = query.get("page") || 1
  const searchQuery = query.get("searchQuery")
  const [tags, setTags] = useState([])

  const searchPost = () => {
    if (search === "" && tags.length === 0) {
      alert("Cannot search for empty values")
    } else {
      if (search.trim() || tags) {
        console.log(tags.length + "  " + search)
        dispatch(getPostsBySearch({search, tags: tags.join(",")}))
        history.push(`/posts/search?searchQuery=${search || "none"}&tags=${tags.join(",")}`)
      } else {
        history.push("/")
      }
    }
  }

  const handleKeyPress = (e) => {
    if (e.keyCode === 13) {
      searchPost()
    }
  }
  const handleAddChip = (tag) => setTags([...tags, tag])
  const handleDeleteChip = (chipToDelete) => setTags(tags.filter((tag) => tag !== chipToDelete))

  return (
    <Grow in>
      <Container maxWidth='xl'>
        <Grid container justify='space-between' alignItems='stretch' spacing={3} className={classes.gridContainer}>
          <Grid item xs={12} sm={6} md={9}>
            <Posts setCurrentId={setCurrentId} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <AppBar className={classes.appBarSearch} position='static' color='inherit'>
              <TextField onKeyDown={handleKeyPress} name='search' variant='outlined' label='Search Memories' fullWidth value={search} onChange={(e) => setSearch(e.target.value)} />
              <ChipInput style={{margin: "10px 0"}} value={tags} onAdd={(chip) => handleAddChip(chip)} onDelete={(chip) => handleDeleteChip(chip)} label='Search Tags' variant='outlined' />
              <Button disableRipple onClick={searchPost} className={classes.searchButton} color='primary' variant='contained'>
                Search
              </Button>
            </AppBar>
            <Form currentId={currentId} setCurrentId={setCurrentId} />
            {!searchQuery && !tags.length && (
              <Paper className={classes.pagination} elevation={6}>
                <Paginate page={page} />
              </Paper>
            )}
          </Grid>
        </Grid>
        <footer className={classes.root}>
          <p>
            Built with pain by{" "}
            <a href='https://github.com/AnshSharmaa' target='_blank' rel='noreferrer' className={classes.git}>
              Ansh
            </a>
          </p>
        </footer>
      </Container>
    </Grow>
  )
}

export default Home
